//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { useForm } from "react-hook-form";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import TextAreaField from "../Reusable/TextAreaField";
import { tw } from "@careinfo/tailwind";

const EditSubject = (props: any) => {
  const { handleEdit, isLoading, data } = props;
  const {
    handleSubmit,
    setError,
    register,
    control,
    formState: { errors },
  } = useForm<any>({
    defaultValues: async () => {
      return {
        title: data?.name,
        extra_data: {
          type: data?.extra_data?.type,
          content: data?.extra_data?.content,
        },
      };
    },
  });

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <TextField
          label={"Title"}
          register={register("title")}
          errors={errors?.title}
        />
      </FormLayout>
    </>
  );
};

export default EditSubject;
